module.exports = "//public.getcloudapp.com/packs/media/images/onboarding/hat-icon-30b1d1c5873ddc59b511ddd4b04ea857.svg";